import { useGetTopProductsQuery } from '../../slices/productApiSlice';
import ProductCarouselSkeleton from '../ui/ProductCarouselSkeleton';
import Message from '../layout/Message';
import { useSelector } from 'react-redux';

import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import '../../assets/styles/product.carousel.css';
import { Autoplay, Pagination } from 'swiper/modules';
import ProductCard from './ProductCard';

const ProductsCarousel = () => {
    const { userInfo } = useSelector((state) => state.auth);
    const {
        data: products,
        isLoading,
        isFetching,
        error,
    } = useGetTopProductsQuery({
        priceAssigned: userInfo?.priceAssigned || null,
    });

    return isLoading || isFetching ? (
        <ProductCarouselSkeleton slides={4} />
    ) : error ? (
        <Message variant="danger">
            {error?.data?.message || error?.error || 'Ocurrió un error inesperado'}
        </Message>
    ) : (
        products &&
        products.length > 0 && (
            <Swiper
                modules={[Pagination, Autoplay]}
                slidesPerView={2.4} // adjust based on screen size later
                spaceBetween={10}
                pagination={{ clickable: true }}
                autoplay={{ delay: 6000 }}
                loop
                simulateTouch={true}
                className="product-swiper"
                breakpoints={{
                    0: { slidesPerView: 2 },
                    320: { slidesPerView: 2.1 },
                    576: { slidesPerView: 3.2 },
                    768: { slidesPerView: 4.2 },
                    1200: { slidesPerView: 5 },
                }}
            >
                {products.map((product) => (
                    <SwiperSlide key={product._id}>
                        <ProductCard product={product} variant="carousel" />
                    </SwiperSlide>
                ))}
            </Swiper>
        )
    );
};

export default ProductsCarousel;
